/**
 * SAI 채팅 상태 관리 스토어
 * 목적: SAI 모달 상태 및 URL 관리
 */
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useSaiChatStore = defineStore('saiChat', () => {
  // State
  const isSaiModalOpen = ref(false);
  const saiUrl = ref('');

  // SAI 새창 열기 함수 (매뉴얼/자주 묻는 질문 팝업과 동일하게 사이드 패널 대신 새창으로 오픈)
  async function openSaiModal() {
    try {
      console.log('SAI 새창 열기 - 토큰 조회 시작');

      // 환경변수에서 SAI 기본 URL 가져오기 (함수 내부에서 호출해야 Nuxt context 사용 가능)
      const runtimeConfig = useRuntimeConfig();
      const saiBaseUrl = runtimeConfig.public.saiUrl;

      // 현재 사용자 정보 가져오기
      const authStore = useAuthStore();
      const user = authStore.user;

      // API를 통해 토큰 조회
      const response = await useApi('/api/common/accessToken.do', {
        method: 'POST',
      });

      const token = response.token;

      // URL 파라미터 구성 (토큰 + 사용자 정보)
      const params = new URLSearchParams();
      params.append('token', token);

      // 사용자 정보가 있으면 추가
      if (user) {
        if (user.compId) params.append('compId', user.compId);
        if (user.userId) params.append('userId', user.userId);
      }

      saiUrl.value = `${saiBaseUrl}?${params.toString()}`;

      const name = 'saiPop';
      const width = 600;
      const height = 800;
      // screen.width/height는 듀얼 모니터에서 주모니터 기준으로 고정되는 경우가 있어,
      // 현재 브라우저 창이 위치한 모니터 기준(screenX/Y + 창 크기)으로 우측 하단을 계산한다.
      const currentMonitorLeft = window.screenLeft ?? window.screenX;
      const currentMonitorTop = window.screenTop ?? window.screenY;
      const currentWindowWidth = window.outerWidth || screen.width;
      const currentWindowHeight = window.outerHeight || screen.height;
      const left = currentMonitorLeft + currentWindowWidth - width;
      const top = currentMonitorTop + currentWindowHeight - height;
      const option = `width=${width},height=${height},left=${left},top=${top},scrollbars=auto,toolbar=no`;
      window.open(saiUrl.value, name, option);

      console.log('SAI 새창 열기 완료:', saiUrl.value);
    } catch (error) {
      console.error('SAI 토큰 조회 실패:', error);
    }
  }

  // SAI 모달 닫기 함수
  function closeSaiModal() {
    isSaiModalOpen.value = false;
  }

  return {
    // State
    isSaiModalOpen,
    saiUrl,
    // Actions
    openSaiModal,
    closeSaiModal,
  };
});
